<template>
    <div></div>
    <!-- <span data-uberall-field="zip"></span><br>
    <span data-uberall-field="province"></span><br>
    <span data-uberall-field="city"></span><br>
    <span data-uberall-field="street"></span><br>
    <span data-uberall-field="phone"></span><br>
    <span data-uberall-field="openingHoursNotes"></span><br>
    <span data-uberall-field="openingHours.Mon"></span><br>
    <span data-uberall-field="openingHours.Tue"></span><br>
    <span data-uberall-field="openingHours.Wed"></span><br>
    <span data-uberall-field="openingHours.Thu"></span><br>
    <span data-uberall-field="openingHours.Fri"></span><br>
    <span data-uberall-field="openingHours.Sat"></span><br>
    <span data-uberall-field="openingHours.Sun"></span><br>
    <span data-uberall-field="specialOpeningHours"></span><br> -->
</template>

<script setup>
import { defineProps, onMounted } from "vue";
import time_sharing_logo from "@/client/assets/images/time_sharing_logo.png";
import {
    getRentalIntervalOverrideConfig,
} from "@/client/api";
import moment from "moment";

const props = defineProps({
    infoSpace: {
        type: Object,
        default: () => ({}),
    },
    description: {
        type: String,
        default: null,
    }
});
const imageWebpResizePath = process.env.VUE_APP_CUSTOMER_URL + "/cdn-cgi/image/format=webp,quality=25";
const imagePaths = props.infoSpace.image.map(img => imageWebpResizePath + img.path_image);
const keywords = props.infoSpace.category_spaces.map(category => category.name);
const res = await getRentalIntervalOverrideConfig(props.infoSpace.rental_space_id)

const getAllPlanTime = res?.data;
let startPlanTimes = [];
let endPlanTimes = [];
let specialOpeningHoursSpecification = [];
let formattedStartPlanTime = null;
let formattedEndPlanTime = null;
let specialOpeningHours = "";
getAllPlanTime?.forEach(plan => {

    plan.rental_space_rental_interval_status.forEach(interval => {
        interval.rental_interval_override_config.forEach(override => {
            if (!startPlanTimes[override.day_ident]) {
                startPlanTimes[override.day_ident] = [];
            }
            if (!endPlanTimes[override.day_ident]) {
                endPlanTimes[override.day_ident] = [];
            }
            startPlanTimes[override.day_ident].push(convertToMinutes(interval.start_time_formatted));
            endPlanTimes[override.day_ident].push(convertToMinutes(interval.end_time_formatted));
        });
    });
});

startPlanTimes.forEach((startTimes, index) => {
    formattedStartPlanTime = startTimes.length ? Math.min(...startTimes) : null;
    formattedEndPlanTime = endPlanTimes[index].length ? Math.max(...endPlanTimes[index]) : null;
    let startPlanTime = formattedStartPlanTime !== null ? convertToTimeString(formattedStartPlanTime) : null;
    let endPlanTime = formattedEndPlanTime !== null ? convertToTimeString(formattedEndPlanTime) : null;
    let dateFromTo = moment(String(index)).format("YYYY-MM-D");
    let specialOpeningHoursSpecificationConfig = {
        "@type": "specialOpeningHoursSpecification",
        "validFrom": dateFromTo,
        "validThrough": dateFromTo,
        "opens": startPlanTime,
        "closes": endPlanTime
    }
    specialOpeningHoursSpecification.push(specialOpeningHoursSpecificationConfig)
    specialOpeningHours += dateFromTo + ' ' + startPlanTime + '～' + endPlanTime + '\n'
});

function convertToMinutes(timeString) {
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + minutes;
}

function convertToTimeString(minutes) {
    const hours = Math.floor(minutes / 60).toString().padStart(2, '0');
    const mins = (minutes % 60).toString().padStart(2, '0');
    return `${hours}:${mins}`;
}
const businessHours = res.businessHours;
const [startTime, endTime] = businessHours.split("～").map(t => t.trim());

let description = props.description ? props.description : props.infoSpace?.general?.general_basic_space_introduction || "";
description = description.split(/(?<=[。.!?])\s*/); // handles both Japanese and English punctuation
description = description.slice(0, 2).join(" ");

const phone = "03-6800-8931";
let paymentAccepted = ["AMEX", "MASTERCARD", "JCB", "VISA", "CASH", "DINERSCLUB"];
const rentalPlanList = props.infoSpace?.plan
    .filter(plan => plan.rental_plan_status == "active");
rentalPlanList?.forEach(plan => {
    if (plan.rental_detail.payment_method_receipt && !paymentAccepted.includes('請求書払い')) {
        paymentAccepted.push('請求書払い');
    }
    if (plan.rental_detail.payment_method_bank_transfer && !paymentAccepted.includes('銀行振込')) {
        paymentAccepted.push('銀行振込');
    }
    if (plan.rental_detail.payment_method_credit_card && !paymentAccepted.includes('クレジットカード')) {
        paymentAccepted.push('クレジットカード');
    }
});
onMounted(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
        "@context": "http://schema.org",
        "@type": "LocalBusiness",
        "@id": window.location.origin + window.location.pathname,
        "image": imagePaths,
        "logo": window.location.origin + time_sharing_logo,
        "name": props.infoSpace?.general?.general_basic_space_name_ja,
        "keywords": keywords,
        "services": [],
        "description": description,
        "address": {
            "@type": "PostalAddress",
            "streetAddress": props.infoSpace?.general?.general_location_prefecture + ' ' + props.infoSpace?.general?.general_location_municipality,
            "addressLocality": props.infoSpace?.general?.general_location_address_ja,
            "postalCode": props.infoSpace?.general?.general_location_post_code,
            "addressCountry": "JP"
        },
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": props.infoSpace?.general?.general_location_latitude,
            "longitude": props.infoSpace?.general?.general_location_longitude,
        },
        "url": window.location.origin + window.location.pathname,
        "telephone": phone,
        "openingHoursSpecification": [
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Monday",
                "opens": startTime,
                "closes": endTime
            },
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Tuesday",
                "opens": startTime,
                "closes": endTime
            },
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Wednesday",
                "opens": startTime,
                "closes": endTime
            },
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Thursday",
                "opens": startTime,
                "closes": endTime
            },
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Friday",
                "opens": startTime,
                "closes": endTime
            },
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Saturday",
                "opens": startTime,
                "closes": endTime
            },
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Sunday",
                "opens": startTime,
                "closes": endTime
            }
        ],
        "specialOpeningHoursSpecification": specialOpeningHoursSpecification,
        "knowsLanguage": ["日本語"],
        "paymentAccepted": paymentAccepted,
        "makesOffer": {
            "@type": "Offer",
            "priceSpecification": []
        }
    }, null, 2);

    document.head.appendChild(script);

    const customScript = document.createElement("script");
    customScript.type = "text/javascript";
    customScript.text = ` const spanArray = document.querySelectorAll("span"); // Use document, not this.$el

    for (let i = 0; i < spanArray.length; i++) {
        const spanAttr = spanArray[i].getAttribute("data-uberall-field");

        if (spanAttr === "zip") {
            spanArray[i].innerHTML = "${props.infoSpace?.general?.general_location_post_code}";
        } else if (spanAttr === "province") {
            spanArray[i].innerHTML = "${props.infoSpace?.general?.general_location_prefecture}";
        } else if (spanAttr === "city") {
            spanArray[i].innerHTML = "${props.infoSpace?.general?.general_location_municipality}";
        } else if (spanAttr === "street") {
            spanArray[i].innerHTML = "${props.infoSpace?.general?.general_location_address_ja}";
        } else if (spanAttr === "addressExtra") {
            spanArray[i].innerHTML = "";
        } else if (spanAttr === "phone") {
            spanArray[i].innerHTML = "${phone}";
        } else if (spanAttr === "openingHoursNotes") {
            spanArray[i].innerHTML = "";
         } else if (spanAttr == "openingHours.Mon") {
            spanArray[i].innerHTML ="${startTime}～${endTime}";
        } else if (spanAttr == "openingHours.Tue") {
            spanArray[i].innerHTML = "${startTime}～${endTime}";
        } else if (spanAttr == "openingHours.Wed") {
            spanArray[i].innerHTML = "${startTime}～${endTime}";
        } else if (spanAttr == "openingHours.Thu") {
            spanArray[i].innerHTML ="${startTime}～${endTime}";
        } else if (spanAttr == "openingHours.Fri") {
            spanArray[i].innerHTML = "${startTime}～${endTime}";
        } else if (spanAttr == "openingHours.Sat") {
            spanArray[i].innerHTML = "${startTime}～${endTime}";
        } else if (spanAttr == "openingHours.Sun") {
            spanArray[i].innerHTML =  "${startTime}～${endTime}";
        } else if (spanAttr == "specialOpeningHours") {
            spanArray[i].innerHTML = "${specialOpeningHours}";
        }
    }`;

    document.head.appendChild(customScript);

    const spanArray = document.querySelectorAll("span"); // Use document, not this.$el

    for (let i = 0; i < spanArray.length; i++) {
        const spanAttr = spanArray[i].getAttribute("data-uberall-field");

        if (spanAttr === "zip") {
            spanArray[i].innerHTML = props.infoSpace?.general?.general_location_post_code;
        } else if (spanAttr === "province") {
            spanArray[i].innerHTML = props.infoSpace?.general?.general_location_prefecture;
        } else if (spanAttr === "city") {
            spanArray[i].innerHTML = props.infoSpace?.general?.general_location_municipality;
        } else if (spanAttr === "street") {
            spanArray[i].innerHTML = props.infoSpace?.general?.general_location_address_ja;
        } else if (spanAttr === "addressExtra") {
            spanArray[i].innerHTML = "";
        } else if (spanAttr === "phone") {
            spanArray[i].innerHTML = phone;
        } else if (spanAttr === "openingHoursNotes") {
            spanArray[i].innerHTML = "";
        } else if (spanAttr == "openingHours.Mon") {
            spanArray[i].innerHTML = startTime + "～" + endTime;
        } else if (spanAttr == "openingHours.Tue") {
            spanArray[i].innerHTML = startTime + "～" + endTime;
        } else if (spanAttr == "openingHours.Wed") {
            spanArray[i].innerHTML = startTime + "～" + endTime;
        } else if (spanAttr == "openingHours.Thu") {
            spanArray[i].innerHTML = startTime + "～" + endTime;
        } else if (spanAttr == "openingHours.Fri") {
            spanArray[i].innerHTML = startTime + "～" + endTime;
        } else if (spanAttr == "openingHours.Sat") {
            spanArray[i].innerHTML = startTime + "～" + endTime;
        } else if (spanAttr == "openingHours.Sun") {
            spanArray[i].innerHTML = startTime + "～" + endTime;
        } else if (spanAttr == "specialOpeningHours") {
            spanArray[i].innerHTML = specialOpeningHours;
        }
    }
});

</script>
